import {
  PublicClientApplication,
  EventType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "862e0830-a016-416b-b6ab-3642fd0fab34",
    authority:
      "https://login.microsoftonline.com/knorrbremsegroup.onmicrosoft.com",
    redirectUri:
      "https://knorr-bremse-trainingfrontend-prod.up.railway.app/login",
  },
  cache: {
    cacheLocation: "sessionStorage", // Use sessionStorage instead of localStorage
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["user.read"], // Define the scopes you need
};

export const authService = {
  msalInstance,

  login: async (redirectUri) => {
    try {
      await msalInstance.loginRedirect({
        ...loginRequest,
        redirectUri,
      });
    } catch (error) {
      console.error("Login error:", error);
      throw error; // Propagate the error to the caller for handling
    }
  },

  logout: () => {
    msalInstance.logout();
  },

  getAccount: () => {
    const accounts = msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  },

  acquireToken: async () => {
    const account = authService.getAccount();
    if (!account) throw new Error("No active account!");

    const request = {
      ...loginRequest,
      account,
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (silentError) {
      console.error("Silent token acquisition error:", silentError);

      // Check if the error is due to interaction required
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await msalInstance.acquireTokenPopup(request);
          return response.accessToken;
        } catch (popupError) {
          console.error("Popup error:", popupError);
          throw popupError;
        }
      } else {
        console.error("Silent token acquisition error:", error);
        throw error;
      }
    }
  },

  clearCache: () => {
    msalInstance.getTokenCache().clear();
  },
};

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const account = msalInstance.getAllAccounts()[0];
    msalInstance.setActiveAccount(account);
  }
});
